export default angular.module('animatronApp.directives', []);




// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/module.ts